module.exports = __webpack_public_path__ + "static/media/book_fall.49ac928f.jpg";